const PRODUCT_TYPES = {
  DIGITAL: "e-lyfr i'w lawrlwytho",
  AUDIOBOOK: 'llyfr sain digidol',
};

const TYPE_CONFIG = {
  [PRODUCT_TYPES.DIGITAL]: {
    assets: {
      overlayLeft:
        'https://cdn.shopify.com/s/files/1/0914/7813/1001/files/welsh-lang-corner-banner_2x_2c48081b-3953-4181-b170-662051680378.png',
      overlayRight:
        'https://cdn.shopify.com/s/files/1/0914/7813/1001/files/lawrlwytho-digidol_2x_2fa74856-342f-4609-a124-05e98f4f0ab8.png',
      formatBanner:
        'https://cdn.shopify.com/s/files/1/0914/7813/1001/files/welsh-lang-light-banner_2x_a4ff22f6-263e-4f7b-a196-ed106ccd748e.png',
    },
    overlayLeftAlt: 'eLyfr',
    overlayRightAlt: 'eLyfr',
    formatBannerAlt: 'eLyfr',
    buyButtonLabel: "Ychwanegu <strong>eLyfr</strong> i'r fasged",
  },
  [PRODUCT_TYPES.AUDIOBOOK]: {
    assets: {
      overlayLeft:
        'https://cdn.shopify.com/s/files/1/0914/7813/1001/files/corner-banner-cy_2x_b8be5341-31cb-493a-92c7-b94f370d3927.png?v=1783500787',
      overlayRight:
        'https://cdn.shopify.com/s/files/1/0914/7813/1001/files/tag-cy_2x_487c69a3-0aad-4d32-a6cd-615e65459908.png?v=1783500787',
      formatBanner:
        'https://cdn.shopify.com/s/files/1/0914/7813/1001/files/alert-cy_2x_8ac3c5f1-ff1d-4668-b3f1-b2e587da5e8a.png?v=1783500787',
    },
    overlayLeftAlt: 'Llyfr Sain',
    overlayRightAlt: 'Llyfr Sain',
    formatBannerAlt: 'Llyfr Sain',
    buyButtonLabel: "Ychwanegu <strong>Llyfr Sain</strong> i'r fasged",
  },
};

const normalizeProductType = (type) => (type || '').trim().toLowerCase();

const getTypeConfig = (type) => TYPE_CONFIG[normalizeProductType(type)] ?? null;

const isProductPage = () => window.location.pathname.includes('/products/');

const isCartPage = () =>
  document.body.classList.contains('template-cart') ||
  window.location.pathname.includes('/cart');

const runProductPageAdditions = () => {
  if (!isProductPage()) return;

  const productType =
    window.productData?.type ?? window.theme?.productData?.type;
  const config = getTypeConfig(productType);
  if (!config) return;

  const { assets } = config;

  const imageContainer = document.querySelector(
    '.product__media.media.media--transparent'
  );
  if (imageContainer && !imageContainer.querySelector('.custom-image-overlay')) {
    imageContainer.classList.add('product-image-wrapper');
    imageContainer.insertAdjacentHTML(
      'beforeend',
      `
        <img class="custom-image-overlay custom-image-overlay--left" src="${assets.overlayLeft}" alt="${config.overlayLeftAlt}" />
        <img class="custom-image-overlay custom-image-overlay--right" src="${assets.overlayRight}" alt="${config.overlayRightAlt}" />
      `
    );
  }

  const formatsEl = document.querySelector('.sf-formats');
  if (formatsEl && !formatsEl.parentElement?.querySelector('.custom-format-banner')) {
    formatsEl.insertAdjacentHTML(
      'afterend',
      `<img class="custom-format-banner" src="${assets.formatBanner}" alt="${config.formatBannerAlt}" />`
    );
  }

  const buyButton = document.querySelector('.product-form__submit');
  if (!buyButton || buyButton.disabled || buyButton.dataset.formatLabelApplied) return;

  const labelSpan = [...buyButton.querySelectorAll('span')].find(
    (span) => !span.closest('.loading__spinner')
  );

  if (labelSpan) {
    labelSpan.innerHTML = config.buyButtonLabel;
    buyButton.dataset.formatLabelApplied = normalizeProductType(productType);
  }
};

const findCartRowForItem = (item) => {
  const byVariant = document
    .querySelector(`tr.cart-item input[data-quantity-variant-id="${item.variant_id}"]`)
    ?.closest('tr.cart-item');
  if (byVariant) return byVariant;

  if (item.handle) {
    const link = document.querySelector(
      `tr.cart-item .cart-item__name[href*="/products/${item.handle}"]`
    );
    if (link) return link.closest('tr.cart-item');
  }

  return null;
};

const addBannerToCartRow = (row, formatBanner, formatBannerAlt) => {
  const detailsCell = row.querySelector('.cart-item__details');
  if (!detailsCell || detailsCell.querySelector('.cart-format-banner')) return;

  const anchor = detailsCell.querySelector('.product-option') || detailsCell;
  anchor.insertAdjacentHTML(
    'afterend',
    `<img class="cart-format-banner" src="${formatBanner}" alt="${formatBannerAlt}" />`
  );
};

const addFormatCartBadges = async () => {
  if (!isCartPage()) return;

  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    if (!cart?.items?.length) return;

    cart.items.forEach((item) => {
      const config = getTypeConfig(item.product_type);
      if (!config) return;

      const row = findCartRowForItem(item);
      if (row) {
        addBannerToCartRow(row, config.assets.formatBanner, config.formatBannerAlt);
      }
    });
  } catch (err) {
    console.error('Cart fetch failed:', err);
  }
};

let cartBadgeTimer = null;

const scheduleFormatCartBadges = () => {
  if (!isCartPage()) return;
  clearTimeout(cartBadgeTimer);
  cartBadgeTimer = setTimeout(addFormatCartBadges, 150);
};

const getCartRoot = () =>
  document.getElementById('main-cart-items') ||
  document.querySelector('cart-items') ||
  document.querySelector('.cart__items') ||
  document.querySelector('form[action="/cart"]');

const observeCartDomChanges = () => {
  const cartRoot = getCartRoot();
  if (!cartRoot) return;

  const observer = new MutationObserver(scheduleFormatCartBadges);
  observer.observe(cartRoot, { childList: true, subtree: true });
};

const patchCartFetch = () => {
  const originalFetch = window.fetch;
  if (originalFetch._formatCartPatched) return;

  window.fetch = function (...args) {
    const result = originalFetch.apply(this, args);
    const url = typeof args[0] === 'string' ? args[0] : args[0]?.url;

    if (url && /\/cart\/(change|update|add|clear)(\.js)?(\?|$)/.test(url)) {
      result.then(() => scheduleFormatCartBadges()).catch(() => {});
    }

    return result;
  };

  window.fetch._formatCartPatched = true;
};

const bindCartUpdateEvents = () => {
  ['cart:updated', 'cart:refresh', 'shopify:section:load'].forEach((event) => {
    document.addEventListener(event, scheduleFormatCartBadges);
  });
};

const initCartBadgePersistence = () => {
  if (!isCartPage()) return;
  observeCartDomChanges();
  patchCartFetch();
  bindCartUpdateEvents();
  scheduleFormatCartBadges();
};

const initCustomFunctions = () => {
  runProductPageAdditions();
  addFormatCartBadges();
  initCartBadgePersistence();
};

document.addEventListener('DOMContentLoaded', initCustomFunctions);